import React from 'react';
import { Construction, Building2, Car, Leaf, Shield, Award } from 'lucide-react';

const services = [
  { icon: <Construction size={15} />, label: 'Road Construction & Reconstruction' },
  { icon: <Building2 size={15} />, label: 'Building Construction & Rehab' },
  { icon: <Car size={15} />, label: 'Car Park Design & Construction' },
  { icon: <Leaf size={15} />, label: 'Landscaping & Erosion Control' },
  { icon: <Shield size={15} />, label: 'Civil Works & Infrastructure' },
  { icon: <Award size={15} />, label: 'Quality-Assured Project Delivery' },
];

const About: React.FC = () => (
  <section className="about-section section-py" id="about">
    <div className="container">
      <div className="about-grid">
        <div style={{ position: 'relative' }}>
          <div className="about-visual-main">
            <svg viewBox="0 0 200 200" fill="none" style={{ width: '60%', height: '60%' }}>
              <rect x="20" y="80" width="60" height="100" fill="rgba(255,255,255,0.15)" rx="3"/>
              <rect x="35" y="95" width="12" height="15" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="53" y="95" width="12" height="15" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="35" y="118" width="12" height="15" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="53" y="118" width="12" height="15" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="90" y="55" width="90" height="125" fill="rgba(255,255,255,0.1)" rx="3"/>
              <rect x="105" y="70" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="125" y="70" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="145" y="70" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="105" y="98" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="125" y="98" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="145" y="98" width="14" height="20" fill="rgba(255,255,255,0.25)" rx="1"/>
              <rect x="117" y="153" width="26" height="27" fill="rgba(255,255,255,0.3)" rx="2"/>
              <line x1="155" y1="10" x2="155" y2="55" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
              <line x1="130" y1="10" x2="175" y2="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
              <circle cx="145" cy="30" r="3" fill="rgba(255,255,255,0.5)"/>
            </svg>
          </div>
          <div className="about-visual-badge">
            <div className="about-visual-badge-num">30+</div>
            <div className="about-visual-badge-text">Years of<br />Excellence</div>
          </div>
        </div>

        <div>
          <div className="section-label">Who We Are</div>
          <h2 className="section-title">Built on Engineering Excellence</h2>
          <p style={{ color:'var(--text-secondary)', lineHeight:'1.85', marginBottom:'18px' }}>
            <strong style={{ color:'var(--text-primary)' }}>NIDAVE Industrial Ventures Limited</strong> is a reputable construction company committed to delivering durable, functional, and high-quality infrastructure solutions. We specialize in the construction and reconstruction of roads, buildings, and related civil works, with a strong focus on safety, efficiency, and long-term value.
          </p>
          <p style={{ color:'var(--text-secondary)', lineHeight:'1.85', marginBottom:'18px' }}>
            With a proven track record in handling both new projects and the rehabilitation of dilapidated infrastructure, we bring technical expertise, skilled workmanship, and a results-driven approach to every assignment.
          </p>
          <p style={{ color:'var(--text-secondary)', lineHeight:'1.85', marginBottom:'32px' }}>
            We combine sound engineering principles, modern construction methods, and strict quality control standards — ensuring every project is executed on schedule, within budget, and to specification.
          </p>
          <div className="section-label" style={{ marginBottom:'16px' }}>Our Services</div>
          <div className="about-services">
            {services.map(s => (
              <div className="service-chip" key={s.label}>{s.icon}{s.label}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
export default About;
